import {
    AnnouncementArchivePage,
    AnnouncementPage,
    BackOrderedPage,
    CFIBackOrdersPage,
    BadRequestPage,
    CFIActionRequiredOrdersPage,
    CFIActionRequiredPage,
    ChangeOrderPage,
    ChangeOrdersPage,
    ContactUsPage,
    CustomerChangeOrdersPage,
    DealerActionRequiredOrdersPage,
    DealerActionRequiredPage,
    DealerChangeOrdersPage,
    DocumentLibraryPage,
    EasyEstimatorPage,
    EditUserPage,
    EEProPage,
    EstimateCustomerContactPage,
    EstimateInfoPage,
    EstimateSchedulePage,
    CFIEstimatesPage,
    EstimateSubmitEstimatePage,
    FAQsPage,
    ForbiddenPage,
    GimbilPage,
    HelpPage,
    MenuPage,
    HomePage,
    SearchPage,
    IntegrationPage,
    LeadNotesPage,
    CFILeadsPage,
    LogoutPage,
    MaterialCostPage,
    CFIMaterialOrdersPage,
    NewStandaloneMaterialOrderPage,
    NewUserPage,
    NotFoundPage,
    CFIOrderSearchPage,
    PaymentScheduleDetailsPage,
    PaymentSchedulePage,
    ProfilePage,
    ResourceGuidesPage,
    RetailOrderActualMeasurePage,
    RetailOrderConfirmPage,
    RetailOrderInfoPage,
    RetailOrderInstallPage,
    RetailOrderMaterialPage,
    RetailOrderNewMaterialPage,
    RetailOrderNotesPage,
    RetailOrderPackingSlipPage,
    RetailOrderSchedulePage,
    CFIRetailOrdersPage,
    RetailOrderTemplatePage,
    RetailOrderUploadCOCPage,
    SageChangeOrdersPage,
    StandaloneMaterialOrderPage,
    UsersPage,
    CFIVanityOrdersPage,
    WorkOrderCompletePage,
    WorkOrderCustomerContactPage,
    WorkOrderInfoPage,
    WorkOrderNotesPage,
    WorkOrderSchedulePage,
    CFIWorkOrdersPage,
    WorkOrderUploadWOCPage,
    DealerOrderSearchPage,
    DealerRetailOrdersPage,
    DealerVanityOrdersPage,
    DealerIMEOrdersPage,
    DealerWorkOrdersPage,
    DealerRetailOrderDetailsPage,
    DealerWorkOrderDetailsPage,
    DealerCFINotesPage,
    DealerEasyEstimatorPage,
    DealerAssignedCFIsPage,
    DealerFAQsPage,
    DistributorActionRequiredPage,
    DistributorActionRequiredOrdersPage,
    PurchaseOrderInfoPage,
    PurchaseOrderValidatePage,
    PurchaseOrderShipPage,
    PurchaseOrderInvoicePage,
    MetricsPage,
    PurchaseOrderSearchPage,
    LateDeliveriesPage,
    PurchaseOrdersPage,
    CreditMemosPage,
    CreditMemoDetailsPage,
    NewCreditMemoPage,
    OutOfStockPage,
    SystemReportsPage,
    CfiRoutingPage,
    DaysToDeliveryPage,
    PurchaseOrderServiceDatePage,
    PurchaseOrderValidateDeliveryPage,
    PurchaseOrderDeliveryDetailsPage,
    RetailOrderPostInstallPage,
    CFIAssignedDistributorsPage,
    InactiveUsersPage,
    CorporateChangeOrdersPage,
    UploadChecklistPage,
    UploadPhotosPage,
    EstimateDetailsPage,
    UploadDesignPage,
    DeliveredToStoreDatePage,
    QualityCheckPage,
    UploadVerificationFormPage,
} from './pages';
import { withNavigationWatcher } from './contexts/navigation';
import { OLD_PORTALS_URL } from "./config/constants";
import CountertopUniversityPage from "./pages/dealer/countertop-university/countertop-university";
import DealerCreateUserPage from "./pages/dealer/user/create-user";
import EasyEstimatorToolPage from "./pages/cfi/easy-estimator-tool/easy-estimator-tool";

const routes = [
    {
        path: '/profile',
        element: ProfilePage
    },
    {
        path: '/logout',
        element: LogoutPage
    },
    {
        path: '/menu',
        element: MenuPage
    },
    {
        path: '/home',
        element: HomePage
    },
    {
        path: '/search',
        element: SearchPage
    },
    {
        path: '/cfi/action-required',
        element: CFIActionRequiredPage
    },
    {
        path: '/cfi/action-required-orders/:actionRequiredID',
        element: CFIActionRequiredOrdersPage
    },
    {
        path: '/cfi/orders',
        element: CFIRetailOrdersPage
    },
    {
        path: '/cfi/orders/retail-orders',
        element: CFIRetailOrdersPage
    },
    {
        path: '/cfi/orders/vanity-orders',
        element: CFIVanityOrdersPage
    },
    {
        path: '/cfi/orders/back-orders',
        element: CFIBackOrdersPage
    },
    {
        path: '/cfi/orders/material-orders',
        element: CFIMaterialOrdersPage
    },
    {
        path: '/cfi/orders/work-orders',
        element: CFIWorkOrdersPage
    },
    {
        path: '/cfi/orders/estimates',
        element: CFIEstimatesPage
    },
    {
        path: '/cfi/orders/leads',
        element: CFILeadsPage
    },
    {
        path: '/cfi/orders/search',
        element: CFIOrderSearchPage
    },
    {
        path: '/cfi/metrics/:tab?',
        element: MetricsPage
    },
    {
        path: '/cfi/easy-estimator',
        element: EasyEstimatorPage
    },
    {
        path: '/cfi/easy-estimator/new',
        element: EEProPage
    },
    {
        path: '/cfi/easy-estimator/:quoteId',
        element: EEProPage
    },
    {
        path: '/dealer/easy-estimator/new',
        element: EEProPage
    },
    {
        path: '/dealer/easy-estimator-old/new',
        element: EasyEstimatorToolPage
    },
    {
        path: '/dealer/easy-estimator-old/:quoteId',
        element: EasyEstimatorToolPage
    },
    {
        path: '/dealer/easy-estimator/:quoteId',
        element: EEProPage
    },
    {
        path: '/portals',
        element: () => {
            window.location.assign(OLD_PORTALS_URL + '?portal_menu_item_id=CFI_ESTIMATEORDER');
            return <p>Redirecting...</p>;
        }
    },
    {
        path: '/cfi/retail-order/:retailOrderID',
        element: RetailOrderInfoPage
    },
    {
        path: '/cfi/retail-order/:retailOrderID/110',
        element: RetailOrderTemplatePage
    },
    {
        path: '/cfi/retail-order/:retailOrderID/111',
        element: RetailOrderTemplatePage
    },
    {
        path: '/cfi/retail-order/:retailOrderID/112',
        element: RetailOrderTemplatePage
    },
    {
        path: '/cfi/retail-order/:retailOrderID/115',
        element: RetailOrderActualMeasurePage
    },
    {
        path: '/cfi/retail-order/:retailOrderID/116',
        element: RetailOrderSchedulePage
    },
    {
        path: '/cfi/retail-order/:retailOrderID/119',
        element: RetailOrderSchedulePage
    },
    {
        path: '/cfi/retail-order/:retailOrderID/120',
        element: RetailOrderConfirmPage
    },
    {
        path: '/cfi/retail-order/:retailOrderID/117',
        element: UploadChecklistPage
    },
    {
        path: '/cfi/retail-order/:retailOrderID/134',
        element: UploadDesignPage
    },
    {
        path: '/cfi/retail-order/:retailOrderID/137',
        element: DeliveredToStoreDatePage
    },
    {
        path: '/cfi/retail-order/:retailOrderID/138',
        element: QualityCheckPage
    },
    {
        path: '/cfi/retail-order/:retailOrderID/143',
        element: RetailOrderSchedulePage
    },
    {
        path: '/cfi/retail-order/:retailOrderID/145',
        element: RetailOrderInstallPage
    },
    {
        path: '/cfi/retail-order/:retailOrderID/155',
        element: RetailOrderInstallPage
    },
    {
        path: '/cfi/retail-order/:retailOrderID/156',
        element: RetailOrderInstallPage
    },
    {
        path: '/cfi/retail-order/:retailOrderID/157',
        element: RetailOrderInstallPage
    },
    {
        path: '/cfi/retail-order/:retailOrderID/147',
        element: UploadPhotosPage
    },
    {
        path: '/cfi/retail-order/:retailOrderID/160',
        element: RetailOrderUploadCOCPage
    },
    {
        path: '/cfi/retail-order/:retailOrderID/162',
        element: UploadVerificationFormPage
    },
    {
        path: '/cfi/retail-order/:retailOrderID/130/:materialOrderID',
        element: RetailOrderMaterialPage
    },
    {
        path: '/cfi/retail-order/:retailOrderID/130',
        element: RetailOrderMaterialPage
    },
    {
        path: '/cfi/retail-order/:retailOrderID/130/new',
        element: RetailOrderNewMaterialPage
    },
    {
        path: '/cfi/retail-order/:retailOrderID/133',
        element: RetailOrderPackingSlipPage
    },
    {
        path: '/cfi/retail-order/:retailOrderID/120/change-order',
        element: ChangeOrderPage
    },
    {
        path: '/cfi/retail-order/:retailOrderID/:actionRequiredID',
        element: RetailOrderInfoPage
    },
    {
        path: '/cfi/material-order/:materialOrderID',
        element: StandaloneMaterialOrderPage
    },
    {
        path: '/cfi/material-order/new',
        element: NewStandaloneMaterialOrderPage
    },
    {
        path: '/cfi/work-order/:workOrderID',
        element: WorkOrderInfoPage
    },
    {
        path: '/cfi/work-order/:workOrderID/410',
        element: WorkOrderCustomerContactPage
    },
    {
        path: '/cfi/work-order/:workOrderID/420',
        element: WorkOrderSchedulePage
    },
    {
        path: '/cfi/work-order/:workOrderID/430',
        element: WorkOrderCompletePage
    },
    {
        path: '/cfi/work-order/:workOrderID/440',
        element: WorkOrderUploadWOCPage
    },
    {
        path: '/cfi/work-order/:workOrderID/:actionRequiredID',
        element: WorkOrderInfoPage
    },
    {
        path: '/cfi/estimate/:quoteID',
        element: EstimateInfoPage
    },
    {
        path: '/cfi/estimate/:quoteID/10',
        element: EstimateCustomerContactPage
    },
    {
        path: '/cfi/estimate/:quoteID/20',
        element: EstimateSchedulePage
    },
    {
        path: '/cfi/estimate/:quoteID/30',
        element: EstimateSubmitEstimatePage
    },
    {
        path: '/cfi/estimate/:quoteID/:actionRequiredID',
        element: EstimateInfoPage
    },
    {
        path: '/cfi/change-orders',
        element: ChangeOrdersPage
    },
    {
        path: '/cfi/change-orders/dealer',
        element: DealerChangeOrdersPage
    },
    {
        path: '/cfi/change-orders/customer',
        element: CustomerChangeOrdersPage
    },
    {
        path: '/cfi/change-orders/sage',
        element: SageChangeOrdersPage
    },
    {
        path: '/cfi/change-orders/corporate',
        element: CorporateChangeOrdersPage
    },
    {
        path: '/cfi/back-ordered',
        element: BackOrderedPage
    },
    {
        path: '/announcement',
        element: AnnouncementPage
    },
    {
        path: '/announcement/archive',
        element: AnnouncementArchivePage
    },
    {
        path: '/cfi/gimbil',
        element: GimbilPage
    },
    {
        path: '/cfi/integration',
        element: IntegrationPage
    },
    {
        path: '/cfi/help',
        element: HelpPage
    },
    {
        path: '/cfi/help/contact-us',
        element: ContactUsPage
    },
    {
        path: '/cfi/help/faqs',
        element: FAQsPage
    },
    {
        path: '/cfi/users',
        element: UsersPage
    },
    {
        path: '/cfi/inactive-users',
        element: InactiveUsersPage
    },
    {
        path: '/cfi/users/user/:userName',
        element: EditUserPage
    },
    {
        path: '/cfi/users/new',
        element: NewUserPage
    },
    {
        path: '/cfi/material-cost',
        element: MaterialCostPage
    },
    {
        path: '/cfi/payment-schedule',
        element: PaymentSchedulePage
    },
    {
        path: '/cfi/payment-schedule/details',
        element: PaymentScheduleDetailsPage
    },
    {
        path: '/cfi/document-library',
        element: DocumentLibraryPage
    },
    {
        path: '/cfi/resource-guide',
        element: ResourceGuidesPage
    },
    {
        path: '/cfi/assigned-distributors',
        element: CFIAssignedDistributorsPage
    },
    {
        path: '/cfi/retail-order-notes',
        element: RetailOrderNotesPage
    },
    {
        path: '/cfi/retail-order-post-install',
        element: RetailOrderPostInstallPage
    },
    {
        path: '/cfi/work-order-notes',
        element: WorkOrderNotesPage
    },
    {
        path: '/cfi/lead-notes',
        element: LeadNotesPage
    },
    {
        path: '/not-found',
        element: NotFoundPage
    },
    {
        path: '/forbidden',
        element: ForbiddenPage
    },
    {
        path: '/bad-request',
        element: BadRequestPage
    },
    {
        path: '/dealer/action-required',
        element: DealerActionRequiredPage
    },
    {
        path: '/dealer/action-required-orders/:actionRequiredID',
        element: DealerActionRequiredOrdersPage
    },
    {
        path: '/dealer/document-library',
        element: DocumentLibraryPage
    },
    {
        path: '/dealer/resource-guide',
        element: ResourceGuidesPage
    },
    {
        path: '/countertop-university/*',
        element: CountertopUniversityPage
    },
    {
        path: '/dealer/help',
        element: DealerFAQsPage
    },
    {
        path: '/dealer/orders/retail-orders',
        element: DealerRetailOrdersPage
    },
    {
        path: '/dealer/orders/vanity-orders',
        element: DealerVanityOrdersPage
    },
    {
        path: '/dealer/orders/ime-orders',
        element: DealerIMEOrdersPage
    },
    {
        path: '/dealer/orders/work-orders',
        element: DealerWorkOrdersPage
    },
    {
        path: '/dealer/orders/search',
        element: DealerOrderSearchPage
    },
    {
        path: '/dealer/retail-order/:retailOrderID',
        element: DealerRetailOrderDetailsPage
    },
    {
        path: '/dealer/work-order/:workOrderID',
        element: DealerWorkOrderDetailsPage
    },
    {
        path: '/dealer/cfi-notes',
        element: DealerCFINotesPage
    },
    {
        path: '/dealer/easy-estimator',
        element: DealerEasyEstimatorPage
    },
    {
        path: '/dealer/assigned-cfis',
        element: DealerAssignedCFIsPage
    },
    {
        path: '/dealer/create-user',
        element: DealerCreateUserPage
    },
    {
        path: '/dealer/inactive-users',
        element: InactiveUsersPage
    },
    {
        path: '/dealer/estimate/:quoteID',
        element: EstimateDetailsPage
    },
    {
        path: '/distributor/document-library',
        element: DocumentLibraryPage
    },
    {
        path: '/distributor/action-required',
        element: DistributorActionRequiredPage
    },
    {
        path: '/distributor/action-required-orders/:actionRequiredID',
        element: DistributorActionRequiredOrdersPage
    },
    {
        path: '/distributor/purchase-order/:purchaseOrderID',
        element: PurchaseOrderInfoPage
    },
    {
        path: '/distributor/purchase-order/:purchaseOrderID/340',
        element: PurchaseOrderValidatePage
    },
    {
        path: '/distributor/purchase-order/:purchaseOrderID/350',
        element: PurchaseOrderShipPage
    },
    {
        path: '/distributor/purchase-order/:purchaseOrderID/341',
        element: PurchaseOrderValidateDeliveryPage
    },
    {
        path: '/distributor/purchase-order/:purchaseOrderID/351',
        element: PurchaseOrderDeliveryDetailsPage
    },
    {
        path: '/distributor/purchase-order/:purchaseOrderID/360',
        element: PurchaseOrderInvoicePage
    },
    {
        path: '/distributor/purchase-order/:purchaseOrderID/360/:poInvoiceID',
        element: PurchaseOrderInvoicePage
    },
    {
        path: '/distributor/purchase-order/:purchaseOrderID/:actionRequiredID',
        element: PurchaseOrderInfoPage
    },
    {
        path: '/distributor/orders',
        element: PurchaseOrdersPage
    },
    {
        path: '/distributor/orders/search',
        element: PurchaseOrderSearchPage
    },
    {
        path: '/distributor/late-deliveries',
        element: LateDeliveriesPage
    },
    {
        path: '/distributor/reports',
        element: SystemReportsPage
    },
    {
        path: '/distributor/credit-memos',
        element: CreditMemosPage
    },
    {
        path: '/distributor/credit-memo/:purchaseOrderID/new',
        element: NewCreditMemoPage
    },
    {
        path: '/distributor/credit-memo/:purchaseOrderID/:creditMemoID',
        element: CreditMemoDetailsPage
    },
    {
        path: '/distributor/out-of-stock',
        element: OutOfStockPage
    },
    {
        path: '/distributor/cfi-routing',
        element: CfiRoutingPage
    },
    {
        path: '/distributor/days-to-delivery',
        element: DaysToDeliveryPage
    },
    {
        path: '/distributor/inactive-users',
        element: InactiveUsersPage
    },
    {
        path: '/manufacturer/document-library',
        element: DocumentLibraryPage
    },
    {
        path: '/manufacturer/action-required',
        element: DistributorActionRequiredPage
    },
    {
        path: '/manufacturer/action-required-orders/:actionRequiredID',
        element: DistributorActionRequiredOrdersPage
    },
    {
        path: '/manufacturer/purchase-order/:purchaseOrderID',
        element: PurchaseOrderInfoPage
    },
    {
        path: '/manufacturer/purchase-order/:purchaseOrderID/340',
        element: PurchaseOrderValidatePage
    },
    {
        path: '/manufacturer/purchase-order/:purchaseOrderID/350',
        element: PurchaseOrderShipPage
    },
    {
        path: '/manufacturer/purchase-order/:purchaseOrderID/341',
        element: PurchaseOrderValidateDeliveryPage
    },
    {
        path: '/manufacturer/purchase-order/:purchaseOrderID/351',
        element: PurchaseOrderDeliveryDetailsPage
    },
    {
        path: '/manufacturer/purchase-order/:purchaseOrderID/360',
        element: PurchaseOrderInvoicePage
    },
    {
        path: '/manufacturer/purchase-order/:purchaseOrderID/360/:poInvoiceID',
        element: PurchaseOrderInvoicePage
    },
    {
        path: '/manufacturer/purchase-order/:purchaseOrderID/:actionRequiredID',
        element: PurchaseOrderInfoPage
    },
    {
        path: '/manufacturer/orders',
        element: PurchaseOrdersPage
    },
    {
        path: '/manufacturer/orders/search',
        element: PurchaseOrderSearchPage
    },
    {
        path: '/manufacturer/late-deliveries',
        element: LateDeliveriesPage
    },
    {
        path: '/manufacturer/reports',
        element: SystemReportsPage
    },
    {
        path: '/manufacturer/credit-memos',
        element: CreditMemosPage
    },
    {
        path: '/manufacturer/credit-memo/:purchaseOrderID/new',
        element: NewCreditMemoPage
    },
    {
        path: '/manufacturer/credit-memo/:purchaseOrderID/:creditMemoID',
        element: CreditMemoDetailsPage
    },
    {
        path: '/manufacturer/out-of-stock',
        element: OutOfStockPage
    },
    {
        path: '/manufacturer/days-to-delivery',
        element: DaysToDeliveryPage
    },
    {
        path: '/manufacturer/inactive-users',
        element: InactiveUsersPage
    },
    {
        path: '/service-provider/action-required',
        element: DistributorActionRequiredPage
    },
    {
        path: '/service-provider/action-required-orders/:actionRequiredID',
        element: DistributorActionRequiredOrdersPage
    },
    {
        path: '/service-provider/purchase-order/:purchaseOrderID',
        element: PurchaseOrderInfoPage
    },
    {
        path: '/service-provider/purchase-order/:purchaseOrderID/370',
        element: PurchaseOrderServiceDatePage
    },
    {
        path: '/service-provider/purchase-order/:purchaseOrderID/380',
        element: PurchaseOrderInvoicePage
    },
    {
        path: '/service-provider/purchase-order/:purchaseOrderID/380/:poInvoiceID',
        element: PurchaseOrderInvoicePage
    },
    {
        path: '/service-provider/purchase-order/:purchaseOrderID/:actionRequiredID',
        element: PurchaseOrderInfoPage
    },
    {
        path: '/service-provider/orders',
        element: PurchaseOrdersPage
    },
    {
        path: '/service-provider/orders/search',
        element: PurchaseOrderSearchPage
    },
    {
        path: '/service-provider/credit-memos',
        element: CreditMemosPage
    },
    {
        path: '/service-provider/credit-memo/:purchaseOrderID/new',
        element: NewCreditMemoPage
    },
    {
        path: '/service-provider/credit-memo/:purchaseOrderID/:creditMemoID',
        element: CreditMemoDetailsPage
    },
    {
        path: '/service-provider/document-library',
        element: DocumentLibraryPage
    },
    {
        path: '/service-provider/inactive-users',
        element: InactiveUsersPage
    }
];

export default routes.map(route => {
    return {
        ...route,
        element: withNavigationWatcher(route.element, route.path)
    };
});
